import React, { useState, useContext } from 'react';
import AppContext from './AppContext';
import PokedexMenuSprite from './PokedexMenuSprite';
import { TYPES_TO_COLORS, beautifyPokemonName } from './helper';

/* Just in time variable needs to be declared in tailwindcss */
// export const TYPES_TO_COLORS_TAILWIND: { [key: string]: string } = {
//   Normal: 'bg-neutral',
//   Fire: 'bg-red',
//   Water: 'bg-blue',
//   Electric: 'bg-yellow',
//   Grass: 'bg-green',
//   Ice: 'bg-cyan',
//   Fighting: 'bg-orange',
//   Poison: 'bg-fuchsia',
//   Ground: 'bg-slate',
//   Flying: 'bg-sky',
//   Psychic: 'bg-purple',
//   Bug: 'bg-lime',
//   Rock: 'bg-stone',
//   Ghost: 'bg-slate',
//   Dragon: 'bg-indigo',
//   Dark: 'bg-gray',
//   Steel: 'bg-zinc',
//   Fairy: 'bg-pink',
// };
// safelist: [
//     'bg-neutral-100',
//     'bg-red-100',
//     'bg-blue-100',

function PokedexSpriteGridCell({
  speciesId,
}: {
  speciesId: string,
}) {
  const [hovered, setHovered] = useState(false);
  const { dex, setClickedSpeciesId, spritePosition } = useContext(AppContext);

  const { types, name } = dex[speciesId];
  const [type1] = types;
  return (
    <>
      {
        /* eslint-disable */
        // HACKY ESLINT-DISABLED FOR JSX
      }
      <div
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        title={beautifyPokemonName(name)}
        onClick={() => setClickedSpeciesId(speciesId)}
        style={{ backgroundColor: `rgba(${TYPES_TO_COLORS[type1].join(',')}, ${hovered ? 0.6 : 0.3})` }}
        className="rounded-lg p-1 cursor-pointer"
      >
        <PokedexMenuSprite key={`${speciesId}-sprite-grid`} currentSpritePosition={spritePosition[speciesId]} />
      </div>
    </>
  );
}

export default PokedexSpriteGridCell;
